export default __webpack_public_path__ + "static/media/redFilledDot.e797bb05.svg";